import {User2faCodeType} from '../../../../service/user-2fa/user-2fa-type';

export function serializeAuthorizationCode(code: string): User2faCodeType {
    const withoutSpaces = code.split(' ').join('');

    return {code: withoutSpaces};
}
